import { getSolutionList } from '@/api/api_solution'

const state = {
  solutionData: []
}

const mutations = {
  SET_SOLUTION_DATA: (state, data) => {
    state.solutionData = data
  }
}

const actions = {
  actions_getSolutionList ({ commit }, tmguid) {
    console.log('actions_getSolutionList--tmguid=' + tmguid)
    state.solutionData = []
    return new Promise((resolve, reject) => {
      getSolutionList(tmguid).then(response => {
        const data = response.data
        if (data.isOk) {
          commit('SET_SOLUTION_DATA', data.data)
          resolve()
        } else {
          reject(data.msg)
        }
      }).catch(error => {
        reject(error)
      })
    })
  }
}

const getters = {
  solutionList: state => state.solutionData
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/solutionListData.js